module.exports = "https://jsak.mmtcdn.com/tripmoney/static/media/IRCTC SBI Platinum Card.6321865b.png";